/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { DevEtlOverviewDto } from './DevEtlOverviewDto';
import {
    DevEtlOverviewDtoFromJSON,
    DevEtlOverviewDtoFromJSONTyped,
    DevEtlOverviewDtoToJSON,
    DevEtlOverviewDtoToJSONTyped,
} from './DevEtlOverviewDto';
import type { DevDailyCountDto } from './DevDailyCountDto';
import {
    DevDailyCountDtoFromJSON,
    DevDailyCountDtoFromJSONTyped,
    DevDailyCountDtoToJSON,
    DevDailyCountDtoToJSONTyped,
} from './DevDailyCountDto';
import type { DevPreferredDemandForecastDto } from './DevPreferredDemandForecastDto';
import {
    DevPreferredDemandForecastDtoFromJSON,
    DevPreferredDemandForecastDtoFromJSONTyped,
    DevPreferredDemandForecastDtoToJSON,
    DevPreferredDemandForecastDtoToJSONTyped,
} from './DevPreferredDemandForecastDto';
import type { DevPriceEventsStatusDto } from './DevPriceEventsStatusDto';
import {
    DevPriceEventsStatusDtoFromJSON,
    DevPriceEventsStatusDtoFromJSONTyped,
    DevPriceEventsStatusDtoToJSON,
    DevPriceEventsStatusDtoToJSONTyped,
} from './DevPriceEventsStatusDto';

/**
 * 
 * @export
 * @interface DevOverviewDto
 */
export interface DevOverviewDto {
    /**
     * 
     * @type {DevEtlOverviewDto}
     * @memberof DevOverviewDto
     */
    etl: DevEtlOverviewDto;
    /**
     * 
     * @type {Array<DevDailyCountDto>}
     * @memberof DevOverviewDto
     */
    priceChanges: Array<DevDailyCountDto>;
    /**
     * 
     * @type {DevPriceEventsStatusDto}
     * @memberof DevOverviewDto
     */
    priceEvents: DevPriceEventsStatusDto;
    /**
     * 
     * @type {Array<DevPreferredDemandForecastDto>}
     * @memberof DevOverviewDto
     */
    preferredDemandForecasts: Array<DevPreferredDemandForecastDto>;
}

/**
 * Check if a given object implements the DevOverviewDto interface.
 */
export function instanceOfDevOverviewDto(value: object): value is DevOverviewDto {
    if (!('etl' in value) || value['etl'] === undefined) return false;
    if (!('priceChanges' in value) || value['priceChanges'] === undefined) return false;
    if (!('priceEvents' in value) || value['priceEvents'] === undefined) return false;
    if (!('preferredDemandForecasts' in value) || value['preferredDemandForecasts'] === undefined) return false;
    return true;
}

export function DevOverviewDtoFromJSON(json: any): DevOverviewDto {
    return DevOverviewDtoFromJSONTyped(json, false);
}

export function DevOverviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevOverviewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'etl': DevEtlOverviewDtoFromJSON(json['etl']),
        'priceChanges': ((json['priceChanges'] as Array<any>).map(DevDailyCountDtoFromJSON)),
        'priceEvents': DevPriceEventsStatusDtoFromJSON(json['priceEvents']),
        'preferredDemandForecasts': ((json['preferredDemandForecasts'] as Array<any>).map(DevPreferredDemandForecastDtoFromJSON)),
    };
}

export function DevOverviewDtoToJSON(json: any): DevOverviewDto {
    return DevOverviewDtoToJSONTyped(json, false);
}

export function DevOverviewDtoToJSONTyped(value?: DevOverviewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'etl': DevEtlOverviewDtoToJSON(value['etl']),
        'priceChanges': ((value['priceChanges'] as Array<any>).map(DevDailyCountDtoToJSON)),
        'priceEvents': DevPriceEventsStatusDtoToJSON(value['priceEvents']),
        'preferredDemandForecasts': ((value['preferredDemandForecasts'] as Array<any>).map(DevPreferredDemandForecastDtoToJSON)),
    };
}

